import { useState, useRef, useEffect, useContext } from 'react';
import { Tabs, Spin } from 'antd';
import { useIntl } from 'react-intl';
import { useSelector } from 'dva';
import { Typography } from 'iglooform';
import EmptyView from '@/components/empty-view/empty-view';
import Context from '@/utils/context';
// import PcContext from '@/utils/context';
import QuotesListItem from '@/components/quotes-list-item/quotes-list-item';
import PoliciesListItem from '@/components/policies-list-item/policies-list-item';
import { getPoliciesList, getQuotesList } from './service';
import { getAgencyInfo } from '@/service';
import './style/policies.less';
// import SkeletonLoading from '@/components/skeleton-loading';
import Loading from '@/components/loading-spin/loading';
import { handleOnScroll } from '@/utils/common';

const { TabPane } = Tabs;

const Policies = () => {
  const { formatMessage } = useIntl();
  const { isPc } = useContext(Context);
  const { currentLang } = useSelector<ReduxState, GlobalState>(
    (state) => state.global,
  );

  const quotesCursor = useRef('0');
  const policiesCursor = useRef('0');
  const tabKey = useRef(localStorage.getItem('POLICYTABKEY') || 'Quotes');

  const [userInfo, setUserInfo] = useState<any>();
  const [policiesList, setPoliciesList] = useState<any>([]);
  const [quotesList, setQuotesList] = useState<any>([]);
  const [isLoading, setLoading] = useState<boolean>(false);

  const getPoliciesData = (isScroll: boolean) => {
    if (window.location.pathname !== '/policies') return;
    if (policiesCursor.current === '' || policiesCursor.current === '1') return;
    if (policiesCursor.current === '0' && isScroll) return;
    getPoliciesList({ cursor: policiesCursor.current, size: 10, order: 'desc' })
      .then((res) => {
        if (res) {
          if (policiesCursor.current === '0') {
            setPoliciesList(res);
          } else {
            if (res.list) {
              setPoliciesList((newObj: any) => {
                return {
                  list: [...newObj.list, ...res.list],
                  cursor: res.cursor,
                };
              });
            }
          }
          policiesCursor.current = res.cursor;
        }
      })
      .finally(() => setLoading(false));
  };

  const getQuotesData = (isScroll: boolean) => {
    if (window.location.pathname !== '/policies') return;
    if (quotesCursor.current === '') return;
    if (quotesCursor.current === '0' && isScroll) return;
    getQuotesList({ cursor: quotesCursor.current, size: 20, order: 'desc' })
      .then((res) => {
        if (res) {
          if (quotesCursor.current === '0') {
            setQuotesList(res);
          } else {
            if (res.list) {
              setQuotesList((newObj: any) => {
                return {
                  list: [...newObj.list, ...res.list],
                  cursor: res.cursor,
                };
              });
            }
          }
          quotesCursor.current = res.cursor;
        }
      })
      .finally(() => setLoading(false));
  };

  const handleChange = (value: any) => {
    localStorage.setItem('POLICYTABKEY', value);
    tabKey.current = value;
    setLoading(true);
    if (value === 'Quotes') {
      policiesCursor.current = '0';
      setPoliciesList(undefined);
      getQuotesData(false);
    } else if (value === 'Policies') {
      quotesCursor.current = '0';
      setQuotesList(undefined);
      getPoliciesData(false);
    }
  };

  useEffect(() => {
    window.addEventListener(
      'scroll',
      handleOnScroll(() => {
        if (tabKey.current === 'Quotes') {
          getQuotesData(true);
        } else if (tabKey.current === 'Policies') {
          getPoliciesData(true);
        }
      }),
    );
    return () => {
      window.removeEventListener(
        'scroll',
        handleOnScroll(() => {
          if (tabKey.current === 'Quotes') {
            getQuotesData(true);
          } else if (tabKey.current === 'Policies') {
            getPoliciesData(true);
          }
        }),
      );
    };
  }, []);

  const getUserInfo = () => {
    getAgencyInfo().then((info: { userInfo: UserInfo }) => {
      if (info && info.userInfo) {
        setUserInfo(info.userInfo);
        sessionStorage.setItem('userStatus', String(info.userInfo.status));
      }
    });
  };

  useEffect(() => {
    getUserInfo();
    setLoading(true);
    if (tabKey.current === 'Quotes') {
      getQuotesData(false);
    } else if (tabKey.current === 'Policies') {
      getPoliciesData(false);
    }
  }, []);

  // if(isLoading){
  //   return (
  //     <div style={{ marginTop: '100px' }}>
  //       <SkeletonLoading />
  //     </div>
  //   )
  // }

  return (
    <section
      className="policies-container"
      style={!isPc ? { marginTop: 24 } : {}}
    >
      <Tabs
        defaultActiveKey={tabKey.current}
        size="large"
        destroyInactiveTabPane={true}
        className="card-out-box"
        onChange={handleChange}
      >
        <TabPane
          tab={
            <Typography level="h2">
              {formatMessage({ id: 'Quotes' })}
            </Typography>
          }
          key="Quotes"
        >
          <Spin indicator={<Loading />} spinning={isLoading}>
            {quotesList &&
              !!quotesList?.list?.length &&
              quotesList.list.map((value: any, index: any) => (
                <QuotesListItem
                  key={index}
                  quotesListItem={value}
                  currentLang={currentLang}
                  userInfo={userInfo}
                />
              ))}
            {!quotesList?.list?.length && !isLoading && (
              <EmptyView
                text={formatMessage({ id: 'You have no policy now.' })}
              />
            )}
          </Spin>
        </TabPane>
        <TabPane
          tab={
            <Typography level="h2">
              {formatMessage({ id: 'Policies' })}
            </Typography>
          }
          key="Policies"
        >
          <Spin indicator={<Loading />} spinning={isLoading}>
            {policiesList &&
              !!policiesList?.list?.length &&
              policiesList.list.map((value: any, index: any) => (
                <PoliciesListItem
                  key={index}
                  policiesListItem={value}
                  currentLang={currentLang}
                  fromPolicy={true}
                />
              ))}
            {!policiesList?.list?.length && !isLoading && (
              <EmptyView
                text={formatMessage({ id: 'You have no policy now.' })}
              />
            )}
          </Spin>
        </TabPane>
      </Tabs>
    </section>
  );
};

export default Policies;
